import React, { useEffect, useState } from 'react'
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useInjectReducer } from "redux-injectors";
import { useInjectSaga } from 'redux-injectors';
import { DropdownIcon } from "app/icons";
import { dateFormatter } from "utils/helpers";
import { reducer, sliceKey, actions } from '../../redux/slice';
import { useUserManagementSaga } from '../../redux/saga'
import { useStyles } from "./styles";
import BreadCrumb from "app/components/BreadCrumb"
import {
  selectUserDetailes,
} from "../../redux/selector";
import { DEPARTMENT_OPTIONS } from "../../types";
import AddUserModal from '../AddUserModal'

const D = "ADMIN_MANAGEMENT.DETAILS";
const T = "ADMIN_MANAGEMENT.TABLE";

const Index = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const dispatch = useDispatch()
const navigate = useNavigate()
const { id } = useParams()
const userDetailes = useSelector(selectUserDetailes)


useInjectReducer({
  key: sliceKey,
  reducer,
});

useInjectSaga({
  key: sliceKey,
  saga: useUserManagementSaga
})

useEffect(() => {
  if (id) {
    dispatch(actions.getUserDetailes(id))
  }
}, [dispatch, id]);

  const isActive = userDetailes?.status === "active";

  const [department, setDepartment] = useState("");

  useEffect(() => {
    setDepartment(userDetailes?.department || "");
  }, [userDetailes]);

  const accountRows = [
    { label: t(`${T}.EMAIL`), value: userDetailes?.email, isEmail: true },
    { label: t(`${T}.PHONE`), value: userDetailes?.mobileNumber },
    {
      label: t(`${D}.CREATED_AT`),
      value: userDetailes?.createdAt ? dateFormatter(userDetailes.createdAt) : "-",
    },
    {
      label: t(`${D}.LAST_LOGIN`),
      value: userDetailes?.lastLogin ? dateFormatter(userDetailes.lastLogin) : "-",
    },
  ];

  return (<Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
             <BreadCrumb
               title={t("SIDEBAR.USER_MANAGEMENT")}
               subTitle={t(`${D}.TITLE`)}
               onBackClick={() => navigate("/users")}
             />
            <Box className={styles.topHeader}>
              
              <Box className={styles.headerLeft}>
                <IconButton size="small" className={styles.collapseButton}>
                  <KeyboardArrowDownIcon />
                </IconButton>
                <span
                  className={`${styles.statusBadge} ${
                    isActive ? styles.statusActive : styles.statusInactive
                  }`}
                >
                  {userDetailes
                    ? t(`ADMIN_MANAGEMENT.STATUS_VALUES.${userDetailes.status.toUpperCase()}`)
                    : "-"}
                </span>
              </Box>
              <Box className={styles.headerRight}>
                <Typography className={styles.userNameText}>
                  {userDetailes?.fullName || "-"}
                </Typography>
                <Avatar className={styles.headerAvatar} src={userDetailes?.profilePic}>
                  {userDetailes?.fullName?.charAt(0)?.toUpperCase()}
                </Avatar>
              </Box>
            </Box>

            <Box className={styles.detailsSection}>
              <Box className={styles.card}>
                <Typography className={styles.cardTitle}>
                  {t(`${D}.PERMISSIONS_TITLE`)}
                </Typography>

                <Box className={styles.field}>
                  <Typography className={styles.label}>{t(`${T}.ROLE`)}</Typography>
                  <Box className={styles.inputBox}>
                    <Typography className={styles.value}>{userDetailes?.role || "-"}</Typography>
                  </Box>
                </Box>

                <Box className={styles.field}>
                  <Typography className={styles.label}>{t(`${T}.DEPARTMENT`)}</Typography>
                  <TextField
                    select
                    fullWidth
                    className={styles.selectField}
                    variant="outlined"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    SelectProps={{
                      IconComponent: DropdownIcon,
                      displayEmpty: true,
                      renderValue: (selected) => {
                        const match = DEPARTMENT_OPTIONS.find((option) => option.value === selected);
                        return match ? t(match.labelKey) : (selected as string) || "-";
                      },
                    }}
                    InputProps={{ notched: false }}
                  >
                    {DEPARTMENT_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value} className={styles.selectMenuItem}>
                        {t(option.labelKey)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Box>

              <Box className={styles.card}>
                <Typography className={styles.cardTitle}>
                  {t(`${D}.ACCOUNT_DETAILS_TITLE`)}
                </Typography>

                <Box className={styles.detailList}>
                  {accountRows.map((row) => (
                    <Box key={row.label} className={styles.detailRow}>
                      <Typography className={styles.label}>{row.label}</Typography>
                      {row.isEmail && row.value ? (
                        <a className={styles.emailLink} href={`mailto:${row.value}`}>
                          {row.value}
                        </a>
                      ) : (
                        <Typography className={`${styles.value} ${styles.detailValue}`}>
                          {row.value || "-"}
                        </Typography>
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
    </Box>
  )
}

export default Index

